"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoggedInUser = void 0;

var jwt_decode_1 = __importDefault(require("jwt-decode"));

var frontend_common_1 = require("@ryerson/frontend.common");

var loggedOutUser = {
  isLoggedIn: false,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  userId: undefined,
  type: undefined,
  roles: undefined,
  token: undefined,
  expires: undefined,
  account: undefined,
  mode: undefined
};
var apimSubscriptionKeyHeader = "ocp-apim-subscription-key";
var authorizationHeader = "authorization";
var callbacks = [];
var retrievingNewToken = false; // requestInterceptors and responseInterceptors will not have any specific type.
// These must be of type any because axios isn't providing a return type at time of writing.

var requestInterceptors = [];
var responseInterceptors = [];

var ejectInterceptorsRequestAndResponse = function ejectInterceptorsRequestAndResponse(axiosInstance) {
  while (requestInterceptors.length > 0) {
    axiosInstance.interceptors.request.eject(requestInterceptors.pop());
  }

  while (responseInterceptors.length > 0) {
    axiosInstance.interceptors.response.eject(responseInterceptors.pop());
  }
};

var setupAxiosInterceptors = function setupAxiosInterceptors(axiosInstance, apimSubscriptionKey, user, setUser, setProfile, setZipCode) {
  // Axios is stacking up all of request and response. There should be only 1 request and 1 response at a time.
  // Because of stacking, it was setting old auth token back once user get logged out adn was adding potential bug.
  ejectInterceptorsRequestAndResponse(axiosInstance); // Request interceptor for API calls

  requestInterceptors.push(axiosInstance.interceptors.request.use(function (config) {
    return new Promise(function (resolve) {
      var _a, _b;

      config.headers[apimSubscriptionKeyHeader] = apimSubscriptionKey;

      if (user.isLoggedIn && !((_a = config.url) === null || _a === void 0 ? void 0 : _a.endsWith(frontend_common_1.ApiUrl.LOGIN))) {
        var now = new Date().getTime() / 1000;
        var expires = user.expires || 0;

        if (expires < now) {
          redirectToLogin(setUser, setProfile, setZipCode);
        }

        if (expires < now + 900 && !((_b = config.url) === null || _b === void 0 ? void 0 : _b.endsWith(frontend_common_1.ApiUrl.REFRESH_TOKEN))) {
          // Expires in the next 15 minutes, so we should refresh the token then proceed.
          if (retrievingNewToken) {
            // Currently getting a new token, hold on to this request.
            callbacks.push({
              resolve: resolve,
              config: config
            });
          } else {
            retrievingNewToken = true;
            refreshToken(config, axiosInstance, setUser, setProfile, setZipCode);
          }
        } else {
          // Set the authorization header
          config.headers[authorizationHeader] = "Bearer " + user.token;
          resolve(config);
        }
      } else {
        resolve(config);
      }
    });
  }, function (error) {
    Promise.reject(error);
  })); // Response interceptor for API calls

  responseInterceptors.push(axiosInstance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    var _a, _b, _c, _d, _e, _f;

    if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && !((_b = error.response.config.url) === null || _b === void 0 ? void 0 : _b.endsWith(frontend_common_1.ApiUrl.LOGIN))) {
      redirectToLogin(setUser, setProfile, setZipCode);
    } else {
      try {
        if ((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.headers) {
          // Headers can contain auth or secret info so we should remove them before logging.
          error.response.config.headers = {};
        }

        if ((_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f.data) {
          // Data can contain sensitive info so we should remove it before logging.
          error.response.config.data = {};
        } // @ts-ignore
        // eslint-disable-next-line no-undef


        Rollbar.error("Error calling an API", error.response);
      } catch (e) {// Don't let an error here kill the API call.
      }

      return error;
    }
  }));
};

var setLoggedInUser = function setLoggedInUser(token, setUser) {
  var decodedToken = (0, jwt_decode_1.default)(token);
  var user = {
    isLoggedIn: true,
    firstName: decodedToken.first,
    lastName: decodedToken.last,
    email: decodedToken.email,
    userId: decodedToken.userid,
    type: decodedToken.utype,
    roles: decodedToken.roles,
    token: token,
    expires: decodedToken.exp,
    account: decodedToken.account,
    mode: decodedToken.mode
  };
  setUser(user);
  return user;
};

exports.setLoggedInUser = setLoggedInUser;

var login = function login(axiosInstance, setUser, userLoginRequest) {
  return new Promise(function (resolve, reject) {
    axiosInstance.post(frontend_common_1.ApiUrl.LOGIN, {
      user: userLoginRequest.username,
      pass: userLoginRequest.password
    }).then(function (response) {
      var status = response.status,
          data = response.data;

      if (status !== 200) {
        return Promise.reject(response);
      } else {
        var user = (0, exports.setLoggedInUser)(data, setUser);
        resolve(user);
      }
    }).catch(function (error) {
      reject(error.response);
    });
  });
};

var logout = function logout(setUser, setProfile, setZipCode) {
  return new Promise(function (resolve) {
    setUser(loggedOutUser);
    setProfile(null);
    setZipCode("");
    localStorage.setItem(frontend_common_1.SessionItems.zipCode, "");
    sessionStorage.setItem(frontend_common_1.SessionItems.loginActive, "false");
    sessionStorage.setItem(frontend_common_1.SessionItems.selectedShipToAddress, "");
    sessionStorage.setItem(frontend_common_1.SessionItems.salesPlant, "");
    sessionStorage.setItem(frontend_common_1.SessionItems.InvoicesTotals, "");
    sessionStorage.setItem(frontend_common_1.SessionItems.myAccountActive, "false");
    resolve(loggedOutUser);
  });
};

var redirectToLogin = function redirectToLogin(setUser, setProfile, setZipCode) {
  logout(setUser, setProfile, setZipCode);
  window === null || window === void 0 ? void 0 : window.location.replace("/login");
};

var refreshToken = function refreshToken(config, axiosInstance, setUser, setProfile, setZipCode) {
  return new Promise(function (resolve) {
    axiosInstance.post(frontend_common_1.ApiUrl.REFRESH_TOKEN).then(function (response) {
      var token = response.data;
      (0, exports.setLoggedInUser)(token, setUser);
      config.headers[authorizationHeader] = "Bearer " + token;
      resolve(config);
      retrievingNewToken = false;
      callbacks.forEach(function (callback) {
        callback.config.headers[authorizationHeader] = "Bearer " + token;
        callback.resolve(config);
      });
      callbacks = [];
    }).catch(function (error) {
      /*eslint-disable no-console*/
      console.log(error);
      redirectToLogin(setUser, setProfile, setZipCode);
    });
  });
};

exports.default = {
  setupAxiosInterceptors: setupAxiosInterceptors,
  login: login,
  logout: logout,
  loggedOutUser: loggedOutUser,
  refreshToken: refreshToken
};